/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { surveyControllerCreate } from '../fn/survey/survey-controller-create';
import { SurveyControllerCreate$Params } from '../fn/survey/survey-controller-create';
import { surveyControllerDelete } from '../fn/survey/survey-controller-delete';
import { SurveyControllerDelete$Params } from '../fn/survey/survey-controller-delete';
import { surveyControllerFindById } from '../fn/survey/survey-controller-find-by-id';
import { SurveyControllerFindById$Params } from '../fn/survey/survey-controller-find-by-id';
import { surveyControllerFindInfo } from '../fn/survey/survey-controller-find-info';
import { SurveyControllerFindInfo$Params } from '../fn/survey/survey-controller-find-info';
import { surveyControllerSearchCursor } from '../fn/survey/survey-controller-search-cursor';
import { SurveyControllerSearchCursor$Params } from '../fn/survey/survey-controller-search-cursor';
import { surveyControllerSearchOffset } from '../fn/survey/survey-controller-search-offset';
import { SurveyControllerSearchOffset$Params } from '../fn/survey/survey-controller-search-offset';
import { SurveyDto } from '../models/survey-dto';
import { SurveyInfoDto } from '../models/survey-info-dto';

@Injectable({ providedIn: 'root' })
export class SurveyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `surveyControllerFindInfo()` */
  static readonly SurveyControllerFindInfoPath = '/api/survey/info';

  /**
   * 만족도 조사 통계 조회.
   *
   * 만족도 조사 통계를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyControllerFindInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerFindInfo$Response(params?: SurveyControllerFindInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyInfoDto>> {
    return surveyControllerFindInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * 만족도 조사 통계 조회.
   *
   * 만족도 조사 통계를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `surveyControllerFindInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerFindInfo(params?: SurveyControllerFindInfo$Params, context?: HttpContext): Observable<SurveyInfoDto> {
    return this.surveyControllerFindInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<SurveyInfoDto>): SurveyInfoDto => r.body)
    );
  }

  /** Path part for operation `surveyControllerSearchOffset()` */
  static readonly SurveyControllerSearchOffsetPath = '/api/survey/search/offset';

  /**
   * 만족도 조사 오프셋 기반 조회.
   *
   * 만족도 조사을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerSearchOffset$Response(params: SurveyControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return surveyControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 만족도 조사 오프셋 기반 조회.
   *
   * 만족도 조사을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `surveyControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerSearchOffset(params: SurveyControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.surveyControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `surveyControllerSearchCursor()` */
  static readonly SurveyControllerSearchCursorPath = '/api/survey/search/cursor';

  /**
   * 만족도 조사 커서 기반 조회.
   *
   * 만족도 조사을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerSearchCursor$Response(params: SurveyControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return surveyControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 만족도 조사 커서 기반 조회.
   *
   * 만족도 조사을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `surveyControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerSearchCursor(params: SurveyControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.surveyControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `surveyControllerFindById()` */
  static readonly SurveyControllerFindByIdPath = '/api/survey/{id}';

  /**
   * 만족도 조사 ID 기반 조회.
   *
   * 만족도 조사을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerFindById$Response(params: SurveyControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyDto>> {
    return surveyControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 만족도 조사 ID 기반 조회.
   *
   * 만족도 조사을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `surveyControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerFindById(params: SurveyControllerFindById$Params, context?: HttpContext): Observable<SurveyDto> {
    return this.surveyControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<SurveyDto>): SurveyDto => r.body)
    );
  }

  /** Path part for operation `surveyControllerDelete()` */
  static readonly SurveyControllerDeletePath = '/api/survey/{id}';

  /**
   * 만족도 조사 삭제.
   *
   * 만족도 조사을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerDelete$Response(params: SurveyControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyDto>> {
    return surveyControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 만족도 조사 삭제.
   *
   * 만족도 조사을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `surveyControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  surveyControllerDelete(params: SurveyControllerDelete$Params, context?: HttpContext): Observable<SurveyDto> {
    return this.surveyControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<SurveyDto>): SurveyDto => r.body)
    );
  }

  /** Path part for operation `surveyControllerCreate()` */
  static readonly SurveyControllerCreatePath = '/api/survey';

  /**
   * 만족도 조사 생성.
   *
   * 만족도 조사을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  surveyControllerCreate$Response(params: SurveyControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyDto>> {
    return surveyControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 만족도 조사 생성.
   *
   * 만족도 조사을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `surveyControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  surveyControllerCreate(params: SurveyControllerCreate$Params, context?: HttpContext): Observable<SurveyDto> {
    return this.surveyControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SurveyDto>): SurveyDto => r.body)
    );
  }

}
